module.exports = "<p>\r\n  facturacion works!\r\n</p>\r\n"